import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { getActiveLanguage } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import slugify from 'slugify';
// import {setFilter} from '../../actions/material/index';

class FilterSubMenuComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show_sub: false
        }
        this.renderSub = this.renderSub.bind(this);
        this.renderGetCount = this.renderGetCount.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(nextProps, this.props);
    }

    isActiveMenu(list_filter, current_filter, applyingFilter, responsive) {
        const check_filter = !responsive ? current_filter : applyingFilter
        if (!check_filter) return '';

        if (typeof check_filter.cat3_id !== "undefined") {
            if (list_filter.cat1_id === check_filter.cat1_id &&
                typeof list_filter.cat2_id === "undefined" &&
                typeof list_filter.cat3_id === "undefined") {
                return 'active';
            } else if (list_filter.cat1_id === check_filter.cat1_id && list_filter.cat2_id === check_filter.cat2_id && typeof list_filter.cat3_id === "undefined") {
                return 'active';
            } else if (list_filter.cat1_id === check_filter.cat1_id && list_filter.cat2_id === check_filter.cat2_id && list_filter.cat3_id === check_filter.cat3_id) {
                return 'active';
            } else {
                return '';
            }
        } else if (typeof check_filter.cat2_id !== "undefined") {
            if (list_filter.cat1_id === check_filter.cat1_id &&
                typeof list_filter.cat2_id === "undefined" &&
                typeof list_filter.cat3_id === "undefined") {
                return 'active';
            } else if (list_filter.cat1_id === check_filter.cat1_id && list_filter.cat2_id === check_filter.cat2_id && typeof list_filter.cat3_id === "undefined") {
                return 'active';
            } else {
                return '';
            }
        } else {
            if (list_filter.cat1_id === check_filter.cat1_id &&
                typeof list_filter.cat2_id === "undefined" &&
                typeof list_filter.cat3_id === "undefined") {
                return 'active';
            } else {
                return '';
            }
        }

    }

    renderSub(sub_menu) {
        const { responsive, filter, translate, queryString, setFilter, applyingFilter, categories, currentLanguage } = this.props;
        return _.map(sub_menu, (m, error) => {
            if (m.subCategories) {
                return <FilterSubMenuComponent translate={translate} key={`${m.cat1_id}_${m.cat2_id}_${m.cat3_id}`} menu={m} setFilter={setFilter} applyingFilter={applyingFilter} filter={this.props.filter} responsive={responsive} countMatByCat={this.props.countMatByCat} queryString={queryString} currentLanguage={currentLanguage} categories={categories} />;
            }
            const count = this.renderGetCount(_.pick(m, ['cat1_id', 'cat2_id', 'cat3_id']));
            if (count === 0) return null
            const cat1 = _.find(categories, (c) => c.cat1_id === m.cat1_id)
            const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === m.cat1_id && c.cat2_id === m.cat2_id) : null;
            const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === m.cat1_id && c.cat2_id === m.cat2_id && c.cat3_id === m.cat3_id) : null;
            const linkUrl = "/shop" + (filter.brand_en ? "/" + filter.brand_en : "") + (cat1 ? "/" + slugify(cat1.category, { lower: true }) : "") + (cat2 ? "/" + slugify(cat2.category, { lower: true }) : "") + (cat3 ? "/" + slugify(cat3.category, { lower: true }) : "") + (queryString ? queryString : "")
            const isActive = this.isActiveMenu(_.pick(m, ['cat1_id', 'cat2_id', 'cat3_id']), this.props.filter, applyingFilter, responsive)
            return (
                <li key={m.category} className={isActive}>
                    <div className="d-flex justify-content-between align-items-center">
                        {!responsive
                            ? <Link to={linkUrl}><span>{currentLanguage === 'th' ? m.category_th : m.category}</span></Link>
                            : <span className={isActive} onClick={() => { setFilter(_.pick(m, ['cat1_id', 'cat2_id', 'cat3_id'])) }}>{currentLanguage === 'th' ? m.category_th : m.category}</span>}
                        <span className="cat-count">{count}</span>
                    </div>

                </li>
            )
        });
    }

    renderGetCount(criteria, sub_category) {
        const { countMatByCat } = this.props;
        if (sub_category) {
            // console.log (sub_category);
            let sum = 0;
            _.each(sub_category, (sub) => {
                if (sub.sub_category) {
                    sum += this.renderGetCount(sub.criteria, sub.sub_category);
                } else {
                    let match = _.findIndex(countMatByCat, (c) => {
                        return (c.cat1_id === sub.criteria.cat1_id) &&
                            ((typeof sub.criteria.cat2_id === "undefined" && c.cat2_id === null) || (typeof sub.criteria.cat2_id !== "undefined" && c.cat2_id === sub.criteria.cat2_id)) &&
                            ((typeof sub.criteria.cat3_id === "undefined" && c.cat3_id === null) || (typeof sub.criteria.cat3_id !== "undefined" && c.cat3_id === sub.criteria.cat3_id));
                    });
                    if (match !== -1) {
                        sum += countMatByCat[match].count;
                    }
                }
            });

            return sum;
        } else {
            let match = _.findIndex(countMatByCat, (c) => {
                return (c.cat1_id === criteria.cat1_id) &&
                    ((typeof criteria.cat2_id === "undefined" && c.cat2_id === null) || (typeof criteria.cat2_id !== "undefined" && c.cat2_id === criteria.cat2_id)) &&
                    ((typeof criteria.cat3_id === "undefined" && c.cat3_id === null) || (typeof criteria.cat3_id !== "undefined" && c.cat3_id === criteria.cat3_id));
            });
            if (match === -1) {
                return 0;
            } else {
                // console.log (countMatByCat[match].count);
                return countMatByCat[match].count;
            }
        }
    }

    render() {
        const { menu, setFilter, filter, responsive, queryString, applyingFilter, categories, currentLanguage } = this.props;
        const isActive = this.isActiveMenu(menu, filter, applyingFilter, responsive);
        const className = responsive ? `main-menu ${isActive ? "sub-open" : ""} ${isActive}` : `main-category ${isActive}`
        const subClassName = responsive ? `sub-menu` : `${(this.state.show_sub || isActive === 'active') ? "show" : "hide"}`
        const count = this.renderGetCount(menu, menu.sub_category);
        if (count !== 0) {
            const cat1 = _.find(categories, (c) => c.cat1_id === menu.cat1_id)
            const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === menu.cat1_id && c.cat2_id === menu.cat2_id) : null;
            const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === menu.cat1_id && c.cat2_id === menu.cat2_id && c.cat3_id === menu.cat3_id) : null;
            const linkUrl = "/shop" + (filter.brand_en ? "/" + filter.brand_en : "") + (cat1 ? "/" + slugify(cat1.category, { lower: true }) : "") + (cat2 ? "/" + slugify(cat2.category, { lower: true }) : "") + (cat3 ? "/" + slugify(cat3.category, { lower: true }) : "") + (queryString ? queryString : "")
            return (
                <li className={className}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <FontAwesomeIcon icon={['fal', 'chevron-right']} className="mr-2" />
                            {/* <span onClick={() => {this.setState({show_sub: !this.state.show_sub}); this.props.setFilter(menu.criteria, !responsive)}}>{translate(menu.name)}</span> */}
                            {!responsive
                                ? <Link to={linkUrl}><span onClick={() => { this.setState({ show_sub: !this.state.show_sub }) }}>{currentLanguage === 'th' ? menu.category_th : menu.category}</span></Link>
                                : <span className={isActive} onClick={() => { this.setState({ show_sub: !this.state.show_sub }); setFilter(_.pick(menu, ['cat1_id', 'cat2_id', 'cat3_id'])) }}>{currentLanguage === 'th' ? menu.category_th : menu.category}</span>}
                        </div>
                        <span className="cat-count">{count}</span>
                    </div>
                    <ul className={subClassName}>
                        {this.renderSub(menu.subCategories)}
                    </ul>
                </li>
            );
        } else {
            return null;
        }

    }
}

class FilterMenuComponent extends Component {
    constructor(props) {
        super(props);

        this.renderMenu = this.renderMenu.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(nextProps, this.props);
    }

    isActiveMenu(list_filter, check_filter) {
        if (list_filter.cat1_id === check_filter.cat1_id && typeof list_filter.cat2_id === "undefined" && typeof list_filter.cat3_id === "undefined") {
            return 'active';
        } else if (list_filter.cat1_id === check_filter.cat1_id && list_filter.cat2_id === check_filter.cat2_id && typeof list_filter.cat3_id === "undefined") {
            return 'active';
        } else if (list_filter.cat1_id === check_filter.cat1_id && list_filter.cat2_id === check_filter.cat2_id && list_filter.cat3_id === check_filter.cat3_id) {
            return 'active';
        } else {
            return '';
        }
    }

    renderMenu(menu) {
        const { filter, setFilter, applyingFilter, responsive, translate, queryString, categories, currentLanguage } = this.props;
        return _.map(menu, (m, index) => {
            if (m.subCategories) {
                return <FilterSubMenuComponent queryString={queryString} applyingFilter={applyingFilter} translate={translate} key={m.category} menu={m} filter={filter} responsive={responsive ? responsive : false} countMatByCat={this.props.countMatByCat} setFilter={setFilter} currentLanguage={currentLanguage} categories={categories} />
            }
            const cat1 = _.find(categories, (c) => c.cat1_id === m.cat1_id)
            const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === m.criteria.cat1_id && c.cat2_id === m.criteria.cat2_id) : null;
            const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === m.criteria.cat1_id && c.cat2_id === m.criteria.cat2_id && c.cat3_id === m.criteria.cat3_id) : null;
            const linkUrl = "/shop" + (filter.brand_en ? "/" + filter.brand_en : "") + (cat1 ? "/" + slugify(cat1.category, { lower: true }) : "") + (cat2 ? "/" + slugify(cat2.category, { lower: true }) : "") + (cat3 ? "/" + slugify(cat3.category, { lower: true }) : "") + (queryString ? queryString : "")
            return <li key={`${m.cat1_id}_${m.cat2_id}_${m.cat3_id}`} className={`${this.isActiveMenu(_.pick(m, ['cat1_id', 'cat2_id', 'cat3_id']), filter)}`}><Link to={linkUrl}><span>{currentLanguage === 'th' ? m.category_th : m.category}</span></Link></li>
        });
    }

    render() {
        const { menu } = this.props;
        return (
            <ul>
                {this.renderMenu(menu)}
            </ul>

        );
    }
}

function mapStateToProps(state) {
    return {
        filter: state.materials.filter,
        countMatByCat: state.materials.countMatByCat,
        currentLanguage: getActiveLanguage(state.locale).code,
        categories: state.itemCategories.categories,
    }
}
export default connect(mapStateToProps, {})(FilterMenuComponent)